var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"error-page main"},[_c('h4',[_vm._v("找不到網頁")]),_c('p',[_vm._v(" 很抱歉，您要找的網頁不存在或已被移除。 ")])])}]

export { render, staticRenderFns }